import * as React from 'react';
import { CommentForm } from './CommentForm';
import { Box, Chip } from '@mui/material';
import { JFormik } from '../forms';
import * as Yup from 'yup';

type CommentProps = {
  createComment: (values: any) => void;
  recipients?: any;
  type?: string;
};

export const AddNewComment = (props: CommentProps) => {
  return (
    <Box
      position="sticky"
      sx={{
        bottom: 0,
        top: 'auto',
        shadow: 'none',
        backgroundColor: 'white',
        px: { xs: 2, sm: 3 },
        py: 2,
      }}
      color="inherit"
    >
      <CommentForm
        handleSubmit={props.createComment}
        recipients={props.recipients}
        type={props.type}
      />
    </Box>
  );
};
